import { Injectable } from '@angular/core';
import { environment } from 'mapfre-auditweb/src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ScheduleEvents } from 'mapfre-auditlib';
import { of } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ScheduleEventsService {

  constructor(private http: HttpClient) { }

  className = 'ScheduleEventsService';

  getEvents() {
    const events = [
      {
        SEVERITY: "HIGH",
        TITLE: "Entrega Informe definitivo",
        DESCRIPTION: "Revisión de sistemas y seguridad",
        DATE: "2019-07-23T18:25:43.511Z"
      },
      {
        SEVERITY: "MEDIUM",
        TITLE: "Entrega Informe definitivo definitivo definitivo",
        DESCRIPTION: "Revisión de sistemas y seguridad",
        DATE: "2019-07-23T18:25:43.511Z"
      },
      {
        SEVERITY: "LOW",
        TITLE: "Entrega Informe definitivo",
        DESCRIPTION: "Revisión de sistemas y seguridad",
        DATE: "2019-07-23T18:25:43.511Z"
      },
      {
        SEVERITY: "LOW",
        TITLE: "Entrega Informe definitivo",
        DESCRIPTION: "Revisión de sistemas y seguridad",
        DATE: "2019-07-24T18:25:43.511Z"
      },
      {
        SEVERITY: "LOW",
        TITLE: "Entrega Informe definitivo",
        DESCRIPTION: "Revisión de sistemas y seguridad",
        DATE: "2019-07-30T18:25:43.511Z"
      }
    ];

    return of(events);

  }
}
